(function () {
  'use strict';
  let backInStockRequestId = 0;
  // The app's document handler calls form.selectVariant before its form is
  // created asynchronously. Wait for the actual variant select before replay.
  function backInStockFormReady(button) {
    const popup = window.BIS && window.BIS.popup;
    const form = popup && popup.form;
    if (button.dataset.bisLoading === 'true' || !form || typeof form.selectVariant !== 'function') return false;
    try {
      const select = form.frameDoc().querySelector('#variants');
      const variantId = button.getAttribute('data-variant-id');
      return !!select && (!variantId || Array.from(select.options).some(option => String(option.value) === variantId));
    } catch (error) {
      return false;
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest && event.target.closest('#BIS_trigger');
    if (!button) return;
    const activeSize = document.querySelector('.pdp-ss__dropdown-option--active, .pdp-ss__size-option--active');
    const variantInput = document.getElementById('product-variant-id');
    const selectedId = activeSize && activeSize.dataset.variantId || variantInput && variantInput.value;
    if (selectedId) button.setAttribute('data-variant-id', selectedId);
    if (backInStockFormReady(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.dataset.bisWaiting === 'true') return;
    const variantId = button.getAttribute('data-variant-id');
    button.dataset.bisWaiting = 'true';
    button.setAttribute('aria-busy', 'true');
    let preparing = false;
    let attempts = 0;
    const timer = setInterval(() => {
      const activeOption = document.querySelector('.pdp-ss__dropdown-option--active, .pdp-ss__size-option--active');
      const cancelled = !button.isConnected || button.classList.contains('pdp-atc-btn--hidden') || button.getAttribute('data-variant-id') !== variantId || (activeOption && activeOption.dataset.variantId !== variantId);
      const popup = window.BIS && window.BIS.popup;
      if (!cancelled && !backInStockFormReady(button) && !preparing && button.dataset.bisLoading !== 'true' && popup && typeof popup.createUI === 'function') {
        preparing = true;
        const activeSize = document.querySelector('.pdp-ss__dropdown-option--active, .pdp-ss__size-option--active');
        renderProductBackInStock(activeSize && activeSize.dataset.productUrl || window.location.pathname);
      }
      const ready = !cancelled && backInStockFormReady(button);
      if (!ready && !cancelled && ++attempts < 150) return;
      clearInterval(timer);
      delete button.dataset.bisWaiting;
      button.removeAttribute('aria-busy');
      if (ready) button.click();
      else if (!cancelled) {
        let status = document.getElementById('bis-loading-status');
        if (!status) {
          status = document.createElement('p');
          status.id = 'bis-loading-status';
          status.setAttribute('role', 'status');
          button.insertAdjacentElement('afterend', status);
        }
        status.textContent = 'Notifications are still loading. Please try again.';
      }
    }, 100);
    const previousStatus = document.getElementById('bis-loading-status');
    if (previousStatus) previousStatus.remove();
  }, true);

  const renderProductBackInStock = async(_productUrl) => {
    const requestId = ++backInStockRequestId;
    if (!_productUrl) return;
    const notifyButton = document.getElementById('BIS_trigger');
    if (notifyButton) notifyButton.dataset.bisLoading = 'true';
    try {
      const response = await fetch(`${_productUrl.split('?')[0]}.js`);
      const product = await response.json();
      const popup = window.BIS && window.BIS.popup;
      if (requestId !== backInStockRequestId || !product.variants || !popup || typeof popup.createUI !== 'function') return;
      document.querySelectorAll('#BIS_frame').forEach(frame => frame.remove());
      popup.product = product;
      if (typeof popup.processProductVariants === 'function') popup.processProductVariants(product);
      popup.createUI();
    } catch (error) {
      // Leave the app's existing popup available if the product request fails.
    } finally {
      if (requestId === backInStockRequestId && notifyButton) delete notifyButton.dataset.bisLoading;
    }
  }

})();
